export default {
  templateUrl: process.env.REACT_APP_AGILE_TEMPLATE_URL || '',
};
